import React, { useEffect } from 'react';
import { useAuth } from './AuthContext';

export default function RequireAuth({ children }: { children: React.ReactElement }) {
  const { user, loading } = useAuth();

  useEffect(() => {
    if (!loading && !user) {
      window.location.href = 'https://shopline-frontend.pages.dev';
    }
  }, [user, loading]);

  if (loading) return null;
  if (!user) return null;

  return children;
}
